import { Route, RouteProps } from 'react-router-dom';
import { useRedirectIfNotValid } from '../../util/hooks';
import { ApplicationStep } from '@payright/types-bnpl-checkout-api';
import { RoutePath } from '../../routes';

export interface CheckoutRouteProps extends RouteProps {
  step: ApplicationStep;
  path: RoutePath;
}

export const CheckoutRoute = ({ step, ...props }: CheckoutRouteProps) => {
  useRedirectIfNotValid();

  return <Route {...props} />;
};
